export default "__VITE_ASSET__D7CNH2Tu__"